/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Guardian Pharmacy - Cart Recommendations */
(function () {
  const selector = '[data-guardian-recommendations]';
  let requestId = 0;

  async function updateRecommendations() {
    const container = document.querySelector(selector);
    if (!container) return;

    const currentRequest = ++requestId;
    container.hidden = true;

    try {
      const cartResponse = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart.js'
      );
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      const excludedIds = new Set(
        cart.items.map(item => String(item.product_id))
      );

      const productIds = [
        ...new Set(cart.items.map(item => item.product_id))
      ];

      const recommendations = [];
      const seenIds = new Set(excludedIds);
const root = window.Shopify?.routes?.root || '/';

for (const productId of productIds) {
  const intents = ['complementary', 'related'];

  const results = await Promise.all(
    intents.map(async intent => {
      const url = new URL(
        root + 'recommendations/products.json',
        window.location.origin
      );

      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '10');
      url.searchParams.set('intent', intent);

      try {
        const response = await fetch(url);
        if (!response.ok) return [];

        const data = await response.json();
        return data.products || [];
      } catch (error) {
        console.warn('Guardian recommendation request:', error);
        return [];
      }
    })
  );

  for (const product of results.flat()) {
    const id = String(product.id);
    if (!product.available || product.requires_selling_plan || seenIds.has(id) ||
        !product.variants?.some(variant => variant.available)) continue;
    seenIds.add(id);
    recommendations.push(product);
    if (recommendations.length === 5) break;
  }
  if (recommendations.length === 5 || currentRequest !== requestId) break;
}

      if (currentRequest !== requestId) {
  console.log('Guardian: request superseded');
  return;
}

if (!recommendations.length || !container.isConnected) return;
      let activeIndex = 0;
      let adding = false;
      const target = container.querySelector(
        '[data-guardian-recommendation-product]'
      );
      if (!target) return;

      container.style.paddingTop = "12px";
      container.style.paddingBottom = "10px";
      target.replaceChildren();
      const slide = document.createElement('div');
      slide.setAttribute('aria-roledescription', 'slide');
      const controls = document.createElement('div');
      controls.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:8px;margin-top:0';
      const pagination = document.createElement('span');
      pagination.style.cssText = 'font-size:13px;min-width:46px;text-align:center;color:#777';
      pagination.setAttribute('aria-live', 'polite');
      pagination.setAttribute('aria-atomic', 'true');
      function arrow(label, direction) {
        const control = document.createElement('button');
        control.type = 'button';
        control.setAttribute('aria-label', label);
        control.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;width:32px;height:28px;padding:0;border:0;background:transparent;color:#777;cursor:pointer';
        const chevron = document.createElement('span');
        chevron.setAttribute('aria-hidden', 'true');
        chevron.style.cssText = 'display:block;width:8px;height:8px;border-top:1.5px solid currentColor;border-right:1.5px solid currentColor;transform:rotate(' + (direction < 0 ? '-135' : '45') + 'deg)';
        control.appendChild(chevron);
        control.addEventListener('click', () => move(direction));
        return control;
      }
      const previous = arrow('Previous recommendation', -1);
      const next = arrow('Next recommendation', 1);
      controls.append(previous, pagination, next);
      controls.hidden = recommendations.length < 2;
      if (recommendations.length < 2) controls.style.display = 'none';
      target.append(slide, controls);
      function move(direction) {
        if (adding || currentRequest !== requestId) return;
        activeIndex = (activeIndex + direction + recommendations.length) % recommendations.length;
        renderSlide();
      }
      let touchStart = null;
      slide.addEventListener('touchstart', event => {
        touchStart = event.touches.length === 1 ? {x:event.touches[0].clientX, y:event.touches[0].clientY} : null;
      }, {passive:true});
      slide.addEventListener('touchend', event => {
        if (!touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touchStart.x;
        const dy = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) move(dx < 0 ? 1 : -1);
      }, {passive:true});
      slide.addEventListener('touchcancel', () => { touchStart = null; });
      function renderSlide() {
      const recommended = recommendations[activeIndex];
      const variant = recommended.variants.find(v => v.available);
      slide.replaceChildren();
      slide.setAttribute('aria-label', (activeIndex + 1) + ' of ' + recommendations.length);
      pagination.textContent = (activeIndex + 1) + ' of ' + recommendations.length;

      const row = document.createElement('div');
      row.className = 'guardian-recommendation-row';

      const link = document.createElement('a');
      link.href = recommended.url;
      link.className = 'guardian-recommendation-link';

      if (recommended.featured_image) {
        const img = document.createElement('img');
        img.src = recommended.featured_image;
        img.alt = recommended.title;
        img.loading = 'lazy';
        link.appendChild(img);
      }

      const details = document.createElement('div');
      details.className = 'guardian-recommendation-details';

      const name = document.createElement('span');
      name.textContent = recommended.title;
      details.appendChild(name);

      const price = document.createElement('span');
      price.className = 'guardian-recommendation-price';
      price.textContent = new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: cart.currency || 'NZD'
      }).format(variant.price / 100);

      details.appendChild(price);
      link.appendChild(details);
      row.appendChild(link);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'guardian-recommendation-add';
      button.textContent = '+ Add';

      button.addEventListener('click', async () => {
        if (adding || currentRequest !== requestId) return;
        adding = true;
        previous.disabled = next.disabled = true;
        button.disabled = true;
        button.textContent = 'Adding...';

        try {
          const response = await fetch(
            (window.Shopify?.routes?.root || '/') + 'cart/add.js',
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: variant.id, quantity: 1 }]
              })
            }
          );

          if (!response.ok) throw new Error('Add failed');

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { scrollToTop: false }
            })
          );
        } catch (error) {
          adding = false;
          previous.disabled = next.disabled = false;
          button.disabled = false;
          button.textContent = 'Try again';
          console.error('Guardian recommendation:', error);
        }
      });

      row.appendChild(button);
      slide.appendChild(row);
      }
      renderSlide();
      container.hidden = false;
    } catch (error) {
      console.error('Guardian recommendations:', error);
    }
  }

 if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateRecommendations);
} else {
  updateRecommendations();
}

let recommendationTimer;

function scheduleRecommendations() {
  ++requestId;
  const container = document.querySelector(selector);
  if (container) container.hidden = true;
  clearTimeout(recommendationTimer);
  recommendationTimer = setTimeout(updateRecommendations, 150);
}

document.documentElement.addEventListener(
  'cart:refresh',
  scheduleRecommendations
);

document.documentElement.addEventListener(
  'product:added',
  scheduleRecommendations
);

const miniCart = document.querySelector('#mini-cart');

if (miniCart) {
  const observer = new MutationObserver((mutations) => {
    const cartChanged = mutations.some(mutation => {
      if (mutation.type !== 'childList') return false;

      const target = mutation.target;

      // Ignore changes made by our recommendation script
      if (
        target.nodeType === 1 &&
        target.closest('[data-guardian-recommendations]')
      ) {
        return false;
      }

      return true;
    });

    if (cartChanged) scheduleRecommendations();
  });

  observer.observe(miniCart, {
    childList: true,
    subtree: true
  });
}
})();

